

// import React, { useState, useCallback, useEffect, useRef } from "react";
// import {
//   Box,
//   Button,
//   Card,
//   CardActions,
//   CardContent,
//   CardHeader,
//   Grid,
//   Snackbar,
//   TextField,
//   Typography,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   IconButton,
//   Divider,
//   CircularProgress,
//   Tooltip,
// } from "@mui/material";
// import { styled } from "@mui/material/styles";
// import MuiAlert from "@mui/material/Alert";
// import CloseIcon from "@mui/icons-material/Close";
// import DeleteIcon from "@mui/icons-material/Delete";
// import AddIcon from "@mui/icons-material/Add";
// import CancelIcon from "@mui/icons-material/Cancel";
// import axios from "axios";
// import config from "../../config.json";

// const { URL } = config;

// // Modern Shimmer effect
// const Shimmer = styled("div")(({ theme }) => ({
//   width: "100%",
//   height: "24px",
//   background: `linear-gradient(90deg, ${theme.palette.grey[100]} 25%, ${theme.palette.grey[200]} 50%, ${theme.palette.grey[100]} 75%)`,
//   backgroundSize: "200% 100%",
//   animation: "shimmer 1s infinite ease-in-out",
//   "@keyframes shimmer": {
//     "0%": { backgroundPosition: "200% 0" },
//     "100%": { backgroundPosition: "-200% 0" },
//   },
//   borderRadius: theme.shape.borderRadius,
//   marginBottom: theme.spacing(1),
// }));

// // Modern SlotCard with hover effect
// const SlotCard = styled(Card)(({ theme }) => ({
//   marginTop: theme.spacing(2),
//   borderRadius: theme.shape.borderRadius * 2,
//   boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
//   backgroundColor: theme.palette.background.paper,
//   transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
//   "&:hover": {
//     transform: "translateY(-6px)",
//     boxShadow: "0 8px 28px rgba(0, 0, 0, 0.12)",
//   },
// }));

// const InterviewSchedulerPage = ({
//   close,
//   handleShortListCandidate,
//   formData,
//   setFormData,
//   sender_EmailId,
//   company_Name,
//   Job_Title,
//   Job_Code,
//   selectedItemName,
//   selectedItems,
//   handleShortListCandidateInBulk,
//   status,
// }) => {
//   const jobTitleRef = useRef(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [openSnackbar, setOpenSnackbar] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("success");
//   const [errors, setErrors] = useState({});
//   const [showNewSlotForm, setShowNewSlotForm] = useState(false);
//   const [hasFetchedSlots, setHasFetchedSlots] = useState(false);
//   const [formDatanew, setFormDataNew] = useState({
//     interviewer: "",
//     interviewTime: "",
//     interviewLocation: "",
//     meetLink: "",
//     candidateEmail: "",
//     interviewerEmail: "",
//     fromDate: "",
//     toDate: "",
//     fromTime: "",
//     toTime: "",
//     interviewType: "",
//     slots: [],
//   });

//   const scrollToInvalidField = (ref) => {
//     if (ref.current) {
//       ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
//     }
//   };

//   useEffect(() => {
//     const fetchSlots = async () => {
//       try {
//         setIsLoading(true);
//         const requisitionId = localStorage.getItem("requisitionId");

//         if (!requisitionId) {
//           setSnackbarMessage("Requisition ID not found. Please try again.");
//           setSnackbarSeverity("error");
//           setOpenSnackbar(true);
//           setShowNewSlotForm(false);
//           return;
//         }

//         const response = await axios.get(`${URL}recruitment/list`, {
//           params: { requisitionId },
//         });

//         const fetchedSlots = response?.data?.data || response?.data;
//         if (fetchedSlots && fetchedSlots.length > 0) {
//           const formattedSlots = fetchedSlots.map((slot) => ({
//             id: slot._id || Date.now() + Math.random(),
//             fromDate: slot.fromDate.split("T")[0] || "",
//             fromTime: slot.fromTime || "",
//             toTime: slot.toTime || "",
//             interviewTime: slot.interviewTime || calculateInterviewTime(slot),
//             interviewer: slot.interviewer || "",
//             interviewerEmail: slot.interviewerEmail || "",
//             interviewType: slot.interviewType || "",
//             meetLink: slot.meetLink || "",
//             interviewLocation: slot.interviewLocation || "",
//             candidates: slot.candidates || [],
//           }));

//           setFormDataNew((prev) => ({
//             ...prev,
//             slots: formattedSlots,
//             interviewer: formattedSlots[0].interviewer,
//             interviewerEmail: formattedSlots[0].interviewerEmail,
//             interviewType: formattedSlots[0].interviewType,
//             meetLink: formattedSlots[0].meetLink,
//             interviewLocation: formattedSlots[0].interviewdivLocation,
//           }));

//           setShowNewSlotForm(false);
//           fetchedSlots.length > 0 && setHasFetchedSlots(true);
//         } else {
//           setFormDataNew((prev) => ({
//             ...prev,
//             slots: [],
//           }));
//           setShowNewSlotForm(false);
//         }
//       } catch (error) {
//         console.error("Error fetching slots:", error);
//         setSnackbarMessage("Failed to fetch slots. Please try again.");
//         setSnackbarSeverity("error");
//         setOpenSnackbar(true);
//         setShowNewSlotForm(false);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchSlots();
//   }, [setFormData]);

//   // Add useEffect to handle scrolling after showNewSlotForm changes
//   useEffect(() => {
//     if (showNewSlotForm && jobTitleRef.current) {
//       setTimeout(() => {
//         scrollToInvalidField(jobTitleRef);
//       }, 100); // Small delay to ensure DOM is updated
//     }
//   }, [showNewSlotForm]);

//   const validateField = (field, value) => {
//     const newErrors = { ...errors };
//     if (!value && ["interviewer", "interviewerEmail", "interviewType"].includes(field)) {
//       newErrors[field] = `${field.replace(/([A-Z])/g, " $1").trim()} is required`;
//     } else if (field === "interviewerEmail" && value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
//       newErrors[field] = "Invalid email format";
//     } else if (field === "meetLink" && formData.interviewType === "Virtual" && !value) {
//       newErrors[field] = "Meet link is required for virtual interviews";
//     } else if (field === "interviewLocation" && formData.interviewType === "In-Person" && !value) {
//       newErrors[field] = "Location is required for in-person interviews";
//     } else {
//       delete newErrors[field];
//     }
//     setErrors(newErrors);
//   };

//   const handleInputChange = useCallback(
//     (e, slotId) => {
//       const { id, value } = e.target;
//       const fieldId = id || (e.target.name === "interviewType" ? "interviewType" : undefined);
//       if (!fieldId) return;

//       validateField(fieldId, value);

//       setFormData((prev) => {
//         const slots = Array.isArray(prev.slots) ? prev.slots : [];

//         if (["interviewer", "interviewerEmail", "interviewType", "meetLink", "interviewLocation"].includes(fieldId)) {
//           const updatedSlots = slots.map((slot) => ({
//             ...slot,
//             interviewer: fieldId === "interviewer" ? value : slot.interviewer,
//             interviewerEmail: fieldId === "interviewerEmail" ? value : slot.interviewerEmail,
//             interviewType: fieldId === "interviewType" ? value : slot.interviewType,
//             meetLink: fieldId === "meetLink" ? value : slot.meetLink,
//             interviewLocation: fieldId === "interviewLocation" ? value : slot.interviewLocation,
//           }));
//           return { ...prev, [fieldId]: value, slots: updatedSlots };
//         }

//         const updatedSlots = slots.map((slot) => {
//           if (slot.id_partition_id === slotId) {
//             const updatedSlot = { ...slot, [fieldId]: value };
//             updatedSlot.interviewTime = calculateInterviewTime(updatedSlot);
//             return updatedSlot;
//           }
//           return slot;
//         });

//         return { ...prev, slots: updatedSlots };
//       });
//     },
//     [setFormData]
//   );

//   const calculateInterviewTime = (slot) => {
//     const { fromDate, fromTime, toTime } = slot;
//     if (fromDate && fromTime && toTime) {
//       const fromDateTime = new Date(`${fromDate}T${fromTime}`);
//       const toDateTime = new Date(`${fromDate}T${toTime}`);
//       if (toDateTime <= fromDateTime) {
//         setSnackbarMessage("End time must be after start time.");
//         setSnackbarSeverity("warning");
//         setOpenSnackbar(true);
//         return "";
//       }
//       const formattedFromTime = fromDateTime.toLocaleTimeString("en-US", {
//         hour: "2-digit",
//         minute: "2-digit",
//         hour12: true,
//       });
//       const formattedToTime = toDateTime.toLocaleTimeString("en-US", {
//         hour: "2-digit",
//         minute: "2-digit",
//         hour12: true,
//       });
//       return `${formattedFromTime} to ${formattedToTime}`;
//     }
//     return "";
//   };

//   const handleAddSlot = () => {
//     const newSlot = {
//       id: Date.now(),
//       fromDate: "",
//       fromTime: "",
//       toTime: "",
//       interviewTime: "",
//       interviewer: formData.interviewer || "",
//       interviewerEmail: formData.interviewerEmail || "",
//       interviewType: formData.interviewType || "",
//       meetLink: formData.meetLink || "",
//       interviewLocation: formData.interviewLocation || "",
//       candidates: [],
//     };
//     setFormData((prev) => ({
//       ...prev,
//       slots: Array.isArray(prev.slots) ? [...prev.slots, newSlot] : [newSlot],
//     }));
//     setShowNewSlotForm(true);
//   };

//   const handleAddAnotherSlot = () => {
//     const newSlot = {
//       id: Date.now(),
//       fromDate: "",
//       fromTime: "",
//       toTime: "",
//       interviewTime: "",
//       interviewer: formData.interviewer || "",
//       interviewerEmail: formData.interviewerEmail || "",
//       interviewType: formData.interviewType || "",
//       meetLink: formData.meetLink || "",
//       interviewLocation: formData.interviewLocation || "",
//       candidates: [],
//     };
//     setFormData((prev) => ({
//       ...prev,
//       slots: Array.isArray(prev.slots) ? [...prev.slots, newSlot] : [newSlot],
//     }));
//   };

//   const handleDeleteSlot = (slotId) => {
//     setFormData((prev) => {
//       const slots = Array.isArray(prev.slots) ? prev.slots : [];
//       const updatedSlots = slots.filter((slot) => slot.id !== slotId);
//       return { ...prev, slots: updatedSlots };
//     });
//     if (formData.slots.length === 1) {
//       setShowNewSlotForm(false);
//     }
//   };

//   const resetForm = () => {
//     setFormData({
//       interviewer: "",
//       interviewerEmail: "",
//       interviewType: "",
//       meetLink: "",
//       interviewLocation: "",
//       slots: [],
//     });
//     setShowNewSlotForm(false);
//     setErrors({});
//   };

//   const handleCancel = () => {
//     resetForm();
//     close();
//   };

//   const handleScheduleConfirm = () => {
//     const requiredFields = ["interviewer", "interviewerEmail", "interviewType"];
//     const newErrors = {};

//     requiredFields.forEach((field) => {
//       if (!formData[field]) {
//         newErrors[field] = `${field.replace(/([A-Z])/g, " $1").trim()} is required`;
//       }
//     });

//     if (formData.interviewType === "Virtual" && !formData.meetLink) {
//       newErrors.meetLink = "Meet link is required for virtual interviews";
//     }
//     if (formData.interviewType === "In-Person" && !formData.interviewLocation) {
//       newErrors.interviewLocation = "Location is required for in-person interviews";
//     }
//     if (!Array.isArray(formData.slots) || formData.slots.length === 0) {
//       setSnackbarMessage("Please add at least one interview slot.");
//       setSnackbarSeverity("warning");
//       setOpenSnackbar(true);
//       return;
//     }
//     if (Object.keys(newErrors).length > 0) {
//       setErrors(newErrors);
//       setSnackbarMessage("Please correct the errors in the form.");
//       setSnackbarSeverity("warning");
//       setOpenSnackbar(true);
//       return;
//     }

//     setIsLoading(true);
//     try {
//       if (status === true) {
//         handleShortListCandidateInBulk(selectedItems, selectedItemName);
//       } else {
//         handleShortListCandidate();
//       }
//       resetForm();
//       close();
//     } catch (error) {
//       setSnackbarMessage(error.response?.data?.error || "Failed to schedule interview.");
//       setSnackbarSeverity("error");
//       setOpenSnackbar(true);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const [showButton, setShowButton] = useState(true);

//   const handleBookSlotClick = (e) => {
//     setShowButton(false);
//     handleAddSlot();
//     // Scroll is handled by useEffect
//   };

//   const handleCancelSlotForm = () => {
//     setShowButton(true)
//     setFormData((prev) => ({
//       ...prev,
//       slots: [],
//     }));
//     setShowNewSlotForm(false);
//     setErrors({});
//   };

//   const handleSnackbarClose = (event, reason) => {
//     if (reason === "clickaway") return;
//     setOpenSnackbar(false);
//   };

//   return (
//     <>
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           minHeight: "100vh",
//           position: "fixed",
//           top: 0,
//           left: 0,
//           right: 0,
//           bottom: 0,
//           zIndex: 1300,
//           p: { xs: 2, sm: 4 },
//           bgcolor: "rgba(0, 0, 0, 0.5)",
//           transition: "background-color 0.3s ease-in-out",
//         }}
//       >
//         <Card
//           sx={{
//             maxWidth: { xs: "95%", sm: 800 },
//             width: "100%",
//             borderRadius: 4,
//             boxShadow: "0 12px 40px rgba(0, 0, 0, 0.2)",
//             bgcolor: "background.paper",
//             display: "flex",
//             flexDirection: "column",
//             maxHeight: { xs: "90vh", sm: "80vh" },
//             "& .MuiTypography-root": { fontFamily: "Inter, sans-serif" },
//             "& .MuiTextField-root": { fontFamily: "Inter, sans-serif" },
//             "& .MuiButton-root": { fontFamily: "Inter, sans-serif" },
//             "& .MuiInputLabel-root": { fontFamily: "Inter, sans-serif" },
//             "& .MuiMenuItem-root": { fontFamily: "Inter, sans-serif" },
//             animation: "fadeIn 0.4s ease-in-out",
//             "@keyframes fadeIn": {
//               from: { opacity: 0, transform: "scale(0.98)" },
//               to: { opacity: 1, transform: "scale(1)" },
//             },
//           }}
//         >
//           <CardHeader
//             title={selectedItemName.length > 1 ? "Bulk Interview Scheduler" : "Schedule Interview"}
//             action={
//               <IconButton
//                 onClick={close}
//                 sx={{ color: "grey.700", "&:hover": { color: "grey.900" } }}
//                 aria-label="Close scheduler"
//               >
//                 <CloseIcon />
//               </IconButton>
//             }
//             sx={{
//               textAlign: "center",
//               bgcolor: "grey.100",
//               py: 2,
//               "& .MuiCardHeader-title": {
//                 fontWeight: 600,
//                 color: "text.primary",
//                 fontSize: { xs: "1.2rem", sm: "1.5rem" },
//               },
//             }}
//           />
//           <CardContent
//             sx={{
//               px: { xs: 3, sm: 4 },
//               py: 3,
//               maxHeight: { xs: "60vh", sm: "50vh" },
//               overflowY: "auto",
//               "&::-webkit-scrollbar": {
//                 width: "8px",
//               },
//               "&::-webkit-scrollbar-track": {
//                 background: "grey.100",
//                 borderRadius: "4px",
//               },
//               "&::-webkit-scrollbar-thumb": {
//                 background: "grey.500",
//                 borderRadius: "4px",
//                 "&:hover": {
//                   background: "grey.700",
//                 },
//               },
//             }}
//           >
//             {isLoading ? (
//               <Box sx={{ my: 4 }}>
//                 <Shimmer />
//                 <Shimmer sx={{ width: "85%" }} />
//                 <Shimmer sx={{ width: "70%" }} />
//               </Box>
//             ) : (
//               <>
//                 <Box sx={{ mb: 3 }}>
//                   <Typography
//                     variant="subtitle1"
//                     sx={{
//                       fontWeight: 600,
//                       color: "text.primary",
//                       fontSize: { xs: "0.9rem", sm: "1rem" },
//                     }}
//                   >
//                     <strong>Job Profile:</strong> {Job_Title} ({Job_Code}) | <strong>Client:</strong> {company_Name}
//                   </Typography>
//                   <Typography
//                     variant="subtitle2"
//                     sx={{
//                       mt: 1,
//                       fontSize: { xs: "0.85rem", sm: "0.95rem" },
//                       color: "text.secondary",
//                     }}
//                   >
//                     <strong>Candidate Email(s):</strong> {selectedItemName.join(", ")}
//                   </Typography>
//                 </Box>
//                 {showButton === true && (
//                   <Box sx={{ mt: 2, textAlign: "center" }}>
//                     <Button
//                       startIcon={<AddIcon />}
//                       onClick={handleBookSlotClick}
//                       sx={{
//                         bgcolor: "#3B82F6",
//                         color: "white",
//                         textTransform: "none",
//                         fontSize: { xs: "0.9rem", sm: "1rem" },
//                         fontWeight: 500,
//                         borderRadius: 2,
//                         px: 4,
//                         py: 1,
//                         "&:hover": { bgcolor: "#2563EB" },
//                         transition: "all 0.3s ease-in-out",
//                       }}
//                       disabled={isLoading}
//                       aria-label="Add new slot"
//                     >
//                       Book Slot
//                     </Button>
//                   </Box>
//                 )}
//                 {hasFetchedSlots ? (
//                   <>
//                     {formDatanew.slots.map((slot) => (
//                       <SlotCard key={slot.id}>
//                         <CardContent sx={{ py: 2, px: 3 }}>
//                           <Grid container spacing={2} alignItems="center">
//                             <Grid item xs={12}>
//                               <Typography
//                                 variant="h6"
//                                 sx={{
//                                   fontSize: { xs: "1rem", sm: "1.25rem" },
//                                   fontWeight: 600,
//                                   color: "text.primary",
//                                 }}
//                               >
//                                 Interview Slot
//                               </Typography>
//                             </Grid>
//                             <Grid item xs={6} sm={4} mutation_id="slot-display-grid-date">
//                               <Typography
//                                 variant="body2"
//                                 sx={{
//                                   fontSize: { xs: "0.85rem", sm: "0.95rem" },
//                                   color: "text.secondary",
//                                 }}
//                               >
//                                 <strong>Date:</strong> {slot.fromDate || "Not set"}
//                               </Typography>
//                             </Grid>
//                             <Grid item xs={6} sm={4}>
//                               <Typography
//                                 variant="body2"
//                                 sx={{
//                                   fontSize: { xs: "0.85rem", sm: "0.95rem" },
//                                   color: "text.secondary",
//                                 }}
//                               >
//                                 <strong>Time:</strong> {slot.interviewTime || "Not set"}
//                               </Typography>
//                             </Grid>
//                             <Grid item xs={6} sm={4}>
//                               <Typography
//                                 variant="body2"
//                                 sx={{
//                                   fontSize: { xs: "0.85rem", sm: "0.95rem" },
//                                   color: "text.secondary",
//                                 }}
//                               >
//                                 <strong>Interviewer:</strong> {slot.interviewer || "Not set"}
//                               </Typography>
//                             </Grid>
//                             <Grid item xs={6} sm={4}>
//                               <Typography
//                                 variant="body2"
//                                 sx={{
//                                   fontSize: { xs: "0.85rem", sm: "0.95rem" },
//                                   color: "text.secondary",
//                                 }}
//                               >
//                                 <strong>Email:</strong> {slot.interviewerEmail || "Not set"}
//                               </Typography>
//                             </Grid>
//                             <Grid item xs={6} sm={4}>
//                               <Typography
//                                 variant="body2"
//                                 sx={{
//                                   fontSize: { xs: "0.85rem", sm: "0.95rem" },
//                                   color: "text.secondary",
//                                 }}
//                               >
//                                 <strong>Type:</strong> {slot.interviewType || "Not set"}
//                               </Typography>
//                             </Grid>
//                             {slot.interviewType === "Virtual" && (
//                               <Grid item xs={6} sm={4}>
//                                 <Typography
//                                   variant="body2"
//                                   sx={{
//                                     fontSize: { xs: "0.85rem", sm: "0.95rem" },
//                                   }}
//                                 >
//                                   <strong>Meet Link:</strong>{" "}
//                                   <a
//                                     href={slot.meetLink}
//                                     target="_blank"
//                                     rel="noopener noreferrer"
//                                     style={{ color: "#3B82F6" }}
//                                   >
//                                     {slot.meetLink || "Not set"}
//                                   </a>
//                                 </Typography>
//                               </Grid>
//                             )}
//                             {slot.interviewType === "In-Person" && (
//                               <Grid item xs={6} sm={4}>
//                                 <Typography
//                                   variant="body2"
//                                   sx={{
//                                     fontSize: { xs: "0.85rem", sm: "0.95rem" },
//                                     color: "text.secondary",
//                                   }}
//                                 >
//                                   <strong>Location:</strong> {slot.interviewLocation || "Not set"}
//                                 </Typography>
//                               </Grid>
//                             )}
//                           </Grid>
//                         </CardContent>
//                         <CardActions sx={{ justifyContent: "flex-end", p: 2 }}>
//                           <Tooltip title="Delete this slot">
//                             <IconButton
//                               onClick={() => handleDeleteSlot(slot.id)}
//                               disabled={isLoading}
//                               sx={{
//                                 color: "error.main",
//                                 "&:hover": { color: "error.dark" },
//                                 fontSize: "1.2rem",
//                               }}
//                               aria-label="Delete slot"
//                             >
//                               <DeleteIcon fontSize="inherit" />
//                             </IconButton>
//                           </Tooltip>
//                         </CardActions>
//                       </SlotCard>
//                     ))}
//                   </>
//                 ) : (
//                   hasFetchedSlots && (
//                     <Box sx={{ textAlign: "center", my: 4 }}>
//                       <Typography
//                         variant="body1"
//                         sx={{
//                           fontSize: { xs: "0.9rem", sm: "1rem" },
//                           color: "text.secondary",
//                           mb: 2,
//                         }}
//                       >
//                         No interview slots available. Add a new slot to schedule an interview.
//                       </Typography>
//                       <Button
//                         startIcon={<AddIcon />}
//                         onClick={handleBookSlotClick}
//                         sx={{
//                           bgcolor: "#3B82F6",
//                           color: "white",
//                           textTransform: "none",
//                           fontSize: { xs: "0.9rem", sm: "1rem" },
//                           fontWeight: 500,
//                           borderRadius: 2,
//                           px: 4,
//                           py: 1,
//                           "&:hover": { bgcolor: "#2563EB" },
//                           transition: "all 0.3s ease-in-out",
//                         }}
//                         disabled={isLoading}
//                         aria-label="Add new slot"
//                       >
//                         Add Slot
//                       </Button>
//                     </Box>
//                   )
//                 )}

//                 {showNewSlotForm && (
//                   <Box ref={jobTitleRef} sx={{ mt: 3, p: 2, bgcolor: "grey.50", borderRadius: 2 }}>
//                     <Typography
//                       variant="h6"
//                       sx={{
//                         fontSize: { xs: "1rem", sm: "1.25rem" },
//                         fontWeight: 600,
//                         mb: 3,
//                         color: "text.primary",
//                       }}
//                     >
//                       Add New Interview Slot
//                     </Typography>
//                     <Grid container spacing={2}>
//                       <Grid item xs={12} sm={6}>
//                         <TextField
//                           fullWidth
//                           label="Interviewer Name"
//                           id="interviewer"
//                           value={formData.interviewer}
//                           onChange={handleInputChange}
//                           error={!!errors.interviewer}
//                           helperText={errors.interviewer}
//                           required
//                           disabled={isLoading}
//                           sx={{
//                             "& .MuiOutlinedInput-root": {
//                               borderRadius: 2,
//                               "& fieldset": { borderColor: "grey.300" },
//                               "&:hover fieldset": { borderColor: "#3B82F6" },
//                               "&.Mui-focused fieldset": { borderColor: "#3B82F6" },
//                               transition: "all 0.3s ease-in-out",
//                             },
//                             "& .MuiInputLabel-root": {
//                               color: "text.secondary",
//                               "&.Mui-focused": { color: "#3B82F6" },
//                               fontSize: { xs: "0.9rem", sm: "1rem" },
//                             },
//                             "& .MuiInputBase-input": { fontSize: { xs: "0.9rem", sm: "1rem" } },
//                             "& .MuiFormHelperText-root": { fontSize: "0.8rem" },
//                           }}
//                         />
//                       </Grid>
//                       <Grid item xs={12} sm={6}>
//                         <TextField
//                           fullWidth
//                           label="Interviewer Email"
//                           id="interviewerEmail"
//                           value={formData.interviewerEmail}
//                           onChange={handleInputChange}
//                           error={!!errors.interviewerEmail}
//                           helperText={errors.interviewerEmail}
//                           required
//                           disabled={isLoading}
//                           sx={{
//                             "& .MuiOutlinedInput-root": {
//                               borderRadius: 2,
//                               "& fieldset": { borderColor: "grey.300" },
//                               "&:hover fieldset": { borderColor: "#3B82F6" },
//                               "&.Mui-focused fieldset": { borderColor: "#3B82F6" },
//                               transition: "all 0.3s ease-in-out",
//                             },
//                             "& .MuiInputLabel-root": {
//                               color: "text.secondary",
//                               "&.Mui-focused": { color: "#3B82F6" },
//                               fontSize: { xs: "0.9rem", sm: "1rem" },
//                             },
//                             "& .MuiInputBase-input": { fontSize: { xs: "0.9rem", sm: "1rem" } },
//                             "& .MuiFormHelperText-root": { fontSize: "0.8rem" },
//                           }}
//                         />
//                       </Grid>
//                       <Grid item xs={12}>
//                         <FormControl fullWidth required error={!!errors.interviewType}>
//                           <InputLabel
//                             sx={{
//                               color: "text.secondary",
//                               "&.Mui-focused": { color: "#3B82F6" },
//                               fontSize: { xs: "0.9rem", sm: "1rem" },
//                             }}
//                           >
//                             Interview Type
//                           </InputLabel>
//                           <Select
//                             name="interviewType"
//                             id="interviewType"
//                             value={formData.interviewType}
//                             onChange={handleInputChange}
//                             disabled={isLoading}
//                             sx={{
//                               borderRadius: 2,
//                               "& .MuiOutlinedInput-notchedOutline": { borderColor: "grey.300" },
//                               "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#3B82F6" },
//                               "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#3B82F6" },
//                               fontSize: { xs: "0.9rem", sm: "1rem" },
//                               transition: "all 0.3s ease-in-out",
//                             }}
//                           >
//                             <MenuItem value="" sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}>
//                               Select Interview Type
//                             </MenuItem>
//                             <MenuItem value="In-Person" sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}>
//                               In-Person
//                             </MenuItem>
//                             <MenuItem value="Virtual" sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}>
//                               Virtual
//                             </MenuItem>
//                           </Select>
//                           {errors.interviewType && (
//                             <Typography
//                               variant="caption"
//                               color="error"
//                               sx={{ fontSize: "0.8rem", mt: 0.5 }}
//                             >
//                               {errors.interviewType}
//                             </Typography>
//                           )}
//                         </FormControl>
//                       </Grid>
//                       {formData.interviewType && (
//                         <Grid item xs={12}>
//                           <TextField
//                             fullWidth
//                             label={formData.interviewType === "Virtual" ? "Platform/Meet Link" : "Interview Location"}
//                             id={formData.interviewType === "Virtual" ? "meetLink" : "interviewLocation"}
//                             value={formData.interviewType === "Virtual" ? formData.meetLink : formData.interviewLocation}
//                             onChange={handleInputChange}
//                             error={!!errors[formData.interviewType === "Virtual" ? "meetLink" : "interviewLocation"]}
//                             helperText={errors[formData.interviewType === "Virtual" ? "meetLink" : "interviewLocation"]}
//                             required={formData.interviewType === "Virtual" || formData.interviewType === "In-Person"}
//                             disabled={isLoading}
//                             sx={{
//                               "& .MuiOutlinedInput-root": {
//                                 borderRadius: 2,
//                                 "& fieldset": { borderColor: "grey.300" },
//                                 "&:hover fieldset": { borderColor: "#3B82F6" },
//                                 "&.Mui-focused fieldset": { borderColor: "#3B82F6" },
//                                 transition: "all 0.3s ease-in-out",
//                               },
//                               "& .MuiInputLabel-root": {
//                                 color: "text.secondary",
//                                 "&.Mui-focused": { color: "#3B82F6" },
//                                 fontSize: { xs: "0.9rem", sm: "1rem" },
//                               },
//                               "& .MuiInputBase-input": { fontSize: { xs: "0.9rem", sm: "1rem" } },
//                               "& .MuiFormHelperText-root": { fontSize: "0.8rem" },
//                             }}
//                           />
//                         </Grid>
//                       )}
//                       {formData.slots.map((slot) => (
//                         <SlotCard key={slot.id} sx={{ mt: 2 }}>
//                           <CardContent sx={{ py: 2, px: 3 }}>
//                             <Grid container spacing={2} alignItems="center">
//                               <Grid item xs={12} sm={4}>
//                                 <TextField
//                                   fullWidth
//                                   type="date"
//                                   label="Interview Date"
//                                   id="fromDate"
//                                   value={slot.fromDate}
//                                   onChange={(e) => handleInputChange(e, slot.id)}
//                                   InputLabelProps={{ shrink: true }}
//                                   required
//                                   disabled={isLoading}
//                                   sx={{
//                                     "& .MuiOutlinedInput-root": {
//                                       borderRadius: 2,
//                                       "& fieldset": { borderColor: "grey.300" },
//                                       "&:hover fieldset": { borderColor: "#3B82F6" },
//                                       "&.Mui-focused fieldset": { borderColor: "#3B82F6" },
//                                       transition: "all 0.3s ease-in-out",
//                                     },
//                                     "& .MuiInputLabel-root": {
//                                       color: "text.secondary",
//                                       "&.Mui-focused": { color: "#3B82F6" },
//                                       fontSize: { xs: "0.9rem", sm: "1rem" },
//                                     },
//                                     "& .MuiInputBase-input": { fontSize: { xs: "0.9rem", sm: "1rem" } },
//                                   }}
//                                 />
//                               </Grid>
//                               <Grid item xs={12} sm={4}>
//                                 <TextField
//                                   fullWidth
//                                   type="time"
//                                   label="Start Time"
//                                   id="fromTime"
//                                   value={slot.fromTime}
//                                   onChange={(e) => handleInputChange(e, slot.id)}
//                                   InputLabelProps={{ shrink: true }}
//                                   required
//                                   disabled={isLoading}
//                                   sx={{
//                                     "& .MuiOutlinedInput-root": {
//                                       borderRadius: 2,
//                                       "& fieldset": { borderColor: "grey.300" },
//                                       "&:hover fieldset": { borderColor: "#3B82F6" },
//                                       "&.Mui-focused fieldset": { borderColor: "#3B82F6" },
//                                       transition: "all 0.3s ease-in-out",
//                                     },
//                                     "& .MuiInputLabel-root": {
//                                       color: "text.secondary",
//                                       "&.Mui-focused": { color: "#3B82F6" },
//                                       fontSize: { xs: "0.9rem", sm: "1rem" },
//                                     },
//                                     "& .MuiInputBase-input": { fontSize: { xs: "0.9rem", sm: "1rem" } },
//                                   }}
//                                 />
//                               </Grid>
//                               <Grid item xs={12} sm={3}>
//                                 <TextField
//                                   fullWidth
//                                   type="time"
//                                   label="End Time"
//                                   id="toTime"
//                                   value={slot.toTime}
//                                   onChange={(e) => handleInputChange(e, slot.id)}
//                                   InputLabelProps={{ shrink: true }}
//                                   required
//                                   disabled={isLoading}
//                                   sx={{
//                                     "& .MuiOutlinedInput-root": {
//                                       borderRadius: 2,
//                                       "& fieldset": { borderColor: "grey.300" },
//                                       "&:hover fieldset": { borderColor: "#3B82F6" },
//                                       "&.Mui-focused fieldset": { borderColor: "#3B82F6" },
//                                       transition: "all 0.3s ease-in-out",
//                                     },
//                                     "& .MuiInputLabel-root": {
//                                       color: "text.secondary",
//                                       "&.Mui-focused": { color: "#3B82F6" },
//                                       fontSize: { xs: "0.9rem", sm: "1rem" },
//                                     },
//                                     "& .MuiInputBase-input": { fontSize: { xs: "0.9rem", sm: "1rem" } },
//                                   }}
//                                 />
//                               </Grid>
//                               <Grid item xs={12} sm={1}>
//                                 <Tooltip title="Delete this slot">
//                                   <IconButton
//                                     onClick={() => handleDeleteSlot(slot.id)}
//                                     disabled={isLoading}
//                                     sx={{
//                                       color: "error.main",
//                                       "&:hover": { color: "error.dark" },
//                                       fontSize: "1.2rem",
//                                     }}
//                                     aria-label="Delete slot"
//                                   >
//                                     <DeleteIcon fontSize="inherit" />
//                                   </IconButton>
//                                 </Tooltip>
//                               </Grid>
//                               {slot.interviewTime && (
//                                 <Grid item xs={12}>
//                                   <Typography
//                                     variant="body2"
//                                     sx={{
//                                       color: "#3B82F6",
//                                       fontSize: { xs: "0.9rem", sm: "1rem" },
//                                       fontWeight: 500,
//                                     }}
//                                   >
//                                     Scheduled: {slot.interviewTime}
//                                   </Typography>
//                                 </Grid>
//                               )}
//                             </Grid>
//                           </CardContent>
//                         </SlotCard>
//                       ))}
//                       <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
//                         <Button
//                           startIcon={<AddIcon />}
//                           onClick={handleAddAnotherSlot}
//                           sx={{
//                             bgcolor: "#10B981",
//                             color: "white",
//                             textTransform: "none",
//                             fontSize: { xs: "0.9rem", sm: "1rem" },
//                             fontWeight: 500,
//                             borderRadius: 2,
//                             px: 4,
//                             py: 1,
//                             "&:hover": { bgcolor: "#059669" },
//                             transition: "all 0.3s ease-in-out",
//                           }}
//                           disabled={isLoading}
//                           aria-label="Add another slot"
//                         >
//                           Add Another Slot
//                         </Button>
//                         <Button
//                           startIcon={<CancelIcon />}
//                           variant="outlined"
//                           onClick={handleCancelSlotForm}
//                           disabled={isLoading}
//                           sx={{
//                             borderColor: "error.main",
//                             color: "error.main",
//                             textTransform: "none",
//                             fontWeight: 500,
//                             fontSize: { xs: "0.9rem", sm: "1rem" },
//                             borderRadius: 2,
//                             px: 4,
//                             py: 1,
//                             "&:hover": { borderColor: "error.dark", bgcolor: "error.light" },
//                             transition: "all 0.3s ease-in-out",
//                           }}
//                           aria-label="Cancel slot form"
//                         >
//                           Cancel
//                         </Button>
//                       </Box>
//                     </Grid>
//                   </Box>
//                 )}
//               </>
//             )}
//           </CardContent>
//           <CardActions sx={{ justifyContent: "space-between", px: { xs: 3, sm: 4 }, py: 2, bgcolor: "grey.100" }}>
//             <Button
//               variant="outlined"
//               onClick={handleCancel}
//               disabled={isLoading}
//               sx={{
//                 borderRadius: 2,
//                 borderColor: "grey.500",
//                 color: "text.primary",
//                 textTransform: "none",
//                 fontWeight: 500,
//                 fontSize: { xs: "0.9rem", sm: "1rem" },
//                 px: 4,
//                 py: 1,
//                 "&:hover": { borderColor: "grey.700", bgcolor: "grey.200" },
//                 transition: "all 0.3s ease-in-out",
//               }}
//               aria-label="Cancel scheduler"
//             >
//               Cancel
//             </Button>
//             <Button
//               variant="contained"
//               onClick={handleScheduleConfirm}
//               disabled={
//                 isLoading ||
//                 selectedItemName.length === 0 ||
//                 !formData.interviewer ||
//                 !formData.slots.length ||
//                 Object.keys(errors).length > 0
//               }
//               sx={{
//                 borderRadius: 2,
//                 bgcolor: "#3B82F6",
//                 color: "#FFFFFF",
//                 textTransform: "none",
//                 fontWeight: 500,
//                 fontSize: { xs: "0.9rem", sm: "1rem" },
//                 px: 4,
//                 py: 1,
//                 "&:hover": { bgcolor: "#2563EB" },
//                 "&.Mui-disabled": { bgcolor: "grey.400", color: "grey.50" },
//                 transition: "all 0.3s ease-in-out",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 1,
//               }}
//               aria-label={selectedItemName.length > 1 ? "Schedule now" : "Save"}
//             >
//               {isLoading ? <CircularProgress size={20} color="inherit" /> : null}
//               {isLoading ? "Scheduling..." : selectedItemName.length > 1 ? "Schedule Now" : "Save"}
//             </Button>
//           </CardActions>
//         </Card>
//       </Box>

//       <Snackbar
//         open={openSnackbar}
//         autoHideDuration={6000}
//         onClose={handleSnackbarClose}
//         anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//         sx={{
//           maxWidth: { xs: "90%", sm: "400px" },
//           mx: "auto",
//           animation: "slideIn 0.3s ease-in-out",
//           "@keyframes slideIn": {
//             from: { opacity: 0, transform: "translateY(20px)" },
//             to: { opacity: "1", transform: "translateY(0)" },
//           },
//         }}
//       >
//         <MuiAlert
//           elevation={6}
//           variant="filled"
//           onClose={handleSnackbarClose}
//           severity={snackbarSeverity}
//           sx={{
//             fontSize: { xs: "0.9rem", sm: "1rem" },
//             borderRadius: 2,
//             boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
//           }}
//         >
//           {snackbarMessage}
//         </MuiAlert>
//       </Snackbar>
//     </>
//   );
// };

// export default InterviewSchedulerPage;




import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  Snackbar,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Divider,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import MuiAlert from "@mui/material/Alert";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import CancelIcon from "@mui/icons-material/Cancel";
import axios from "axios";
import config from "../../config.json";

const { URL } = config;

// Modern Shimmer effect
const Shimmer = styled("div")(({ theme }) => ({
  width: "100%",
  height: "24px",
  background: `linear-gradient(90deg, ${theme.palette.grey[100]} 25%, ${theme.palette.grey[200]} 50%, ${theme.palette.grey[100]} 75%)`,
  backgroundSize: "200% 100%",
  animation: "shimmer 1s infinite ease-in-out",
  "@keyframes shimmer": {
    "0%": { backgroundPosition: "200% 0" },
    "100%": { backgroundPosition: "-200% 0" },
  },
  borderRadius: theme.shape.borderRadius,
  marginBottom: theme.spacing(1),
}));

// Modern SlotCard with hover effect
const SlotCard = styled(Card)(({ theme }) => ({
  marginTop: theme.spacing(2),
  borderRadius: theme.shape.borderRadius * 2,
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
  backgroundColor: theme.palette.background.paper,
  transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
  "&:hover": {
    transform: "translateY(-6px)",
    boxShadow: "0 8px 28px rgba(0, 0, 0, 0.12)",
  },
}));

const InterviewSchedulerPage = ({
  close,
  handleShortListCandidate,
  formData,
  setFormData,
  sender_EmailId,
  company_Name,
  Job_Title,
  Job_Code,
  selectedItemName,
  selectedItems,
  handleShortListCandidateInBulk,
  status,
}) => {
  const jobTitleRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [errors, setErrors] = useState({});
  const [showNewSlotForm, setShowNewSlotForm] = useState(false);
  const [hasFetchedSlots, setHasFetchedSlots] = useState(false);
  const [fetchedSlots, setFetchedSlots] = useState([]);
  const [showButton, setShowButton] = useState(true);

  const scrollToInvalidField = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  useEffect(() => {
    const fetchSlots = async () => {
      try {
        setIsLoading(true);
        const requisitionId = localStorage.getItem("requisitionId");

        if (!requisitionId) {
          setSnackbarMessage("Requisition ID not found. Please try again.");
          setSnackbarSeverity("error");
          setOpenSnackbar(true);
          return;
        }

        const response = await axios.get(`${URL}/recruitment/list`, {
          params: { requisitionId },
        });

        const fetchedSlotsData = response?.data?.data || response?.data || [];
        setFetchedSlots(
          fetchedSlotsData.map((slot) => ({
            id: slot._id || Date.now() + Math.random(),
            fromDate: slot.fromDate?.split("T")[0] || "",
            fromTime: slot.fromTime || "",
            toTime: slot.toTime || "",
            interviewTime: slot.interviewTime || calculateInterviewTime(slot),
            interviewer: slot.interviewer || "",
            interviewerEmail: slot.interviewerEmail || "",
            interviewType: slot.interviewType || "",
            meetLink: slot.meetLink || "",
            interviewLocation: slot.interviewLocation || "",
            candidates: slot.candidates || [],
          }))
        );
        setHasFetchedSlots(true);
      } catch (error) {
        console.error("Error fetching slots:", error);
        setSnackbarMessage("Failed to fetch slots. Please try again.");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSlots();
  }, []);

  useEffect(() => {
    if (showNewSlotForm && jobTitleRef.current) {
      scrollToInvalidField(jobTitleRef);
    }
  }, [showNewSlotForm]);

  const validateField = (field, value, slotIndex = null) => {
    const newErrors = { ...errors };
    if (
      !value &&
      ["interviewer", "interviewerEmail", "interviewType", "fromDate", "fromTime", "toTime"].includes(field)
    ) {
      newErrors[slotIndex !== null ? `${field}_${slotIndex}` : field] = `${
        field.replace(/([A-Z])/g, " $1").trim()
      } is required`;
    } else if (field === "interviewerEmail" && value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      newErrors.interviewerEmail = "Invalid email format";
    } else if (field === "meetLink" && formData.interviewType === "Virtual" && !value) {
      newErrors.meetLink = "Meet link is required for virtual interviews";
    } else if (field === "interviewLocation" && formData.interviewType === "In-Person" && !value) {
      newErrors.interviewLocation = "Location is required for in-person interviews";
    } else {
      delete newErrors[slotIndex !== null ? `${field}_${slotIndex}` : field];
    }
    setErrors(newErrors);
  };

  const handleInputChange = useCallback(
    (e, slotId) => {
      const { id, value, name } = e.target;
      const fieldId = id || name;
      if (!fieldId) return;

      if (["interviewer", "interviewerEmail", "interviewType", "meetLink", "interviewLocation"].includes(fieldId)) {
        validateField(fieldId, value);
        setFormData((prev) => ({
          ...prev,
          [fieldId]: value,
          slots: prev.slots.map((slot) => ({
            ...slot,
            [fieldId]: value,
          })),
        }));
      } else {
        const slotIndex = formData.slots.findIndex((slot) => slot.id === slotId);
        validateField(fieldId, value, slotIndex);
        setFormData((prev) => {
          const updatedSlots = prev.slots.map((slot) =>
            slot.id === slotId
              ? {
                  ...slot,
                  [fieldId]: value,
                  interviewTime: calculateInterviewTime({ ...slot, [fieldId]: value }),
                }
              : slot
          );
          return { ...prev, slots: updatedSlots };
        });
      }
    },
    [formData.slots, setFormData]
  );

  const calculateInterviewTime = (slot) => {
    const { fromDate, fromTime, toTime } = slot;
    if (!fromDate || !fromTime || !toTime) return "";

    const fromDateTime = new Date(`${fromDate}T${fromTime}`);
    const toDateTime = new Date(`${fromDate}T${toTime}`);
    if (toDateTime <= fromDateTime) {
      setSnackbarMessage("End time must be after start time.");
      setSnackbarSeverity("warning");
      setOpenSnackbar(true);
      return "";
    }

    const formattedFromTime = fromDateTime.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    const formattedToTime = toDateTime.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    return `${formattedFromTime} to ${formattedToTime}`;
  };

  const handleAddSlot = () => {
    const newSlot = {
      id: Date.now(),
      fromDate: "",
      fromTime: "",
      toTime: "",
      interviewTime: "",
      interviewer: formData.interviewer || "",
      interviewerEmail: formData.interviewerEmail || "",
      interviewType: formData.interviewType || "",
      meetLink: formData.meetLink || "",
      interviewLocation: formData.interviewLocation || "",
      candidates: [],
    };
    setFormData((prev) => ({
      ...prev,
      slots: [...(prev.slots || []), newSlot],
    }));
    setShowNewSlotForm(true);
    setShowButton(false);
  };

  const handleAddAnotherSlot = () => {
    const newSlot = {
      id: Date.now(),
      fromDate: "",
      fromTime: "",
      toTime: "",
      interviewTime: "",
      interviewer: formData.interviewer || "",
      interviewerEmail: formData.interviewerEmail || "",
      interviewType: formData.interviewType || "",
      meetLink: formData.meetLink || "",
      interviewLocation: formData.interviewLocation || "",
      candidates: [],
    };
    setFormData((prev) => ({
      ...prev,
      slots: [...prev.slots, newSlot],
    }));
  };

  const handleDeleteSlot = (slotId) => {
    setFormData((prev) => ({
      ...prev,
      slots: prev.slots.filter((slot) => slot.id !== slotId),
    }));
    if (formData.slots.length === 1) {
      setShowNewSlotForm(false);
      setShowButton(true);
    }
  };

  const resetForm = () => {
    setFormData({
      interviewer: "",
      interviewerEmail: "",
      interviewType: "",
      meetLink: "",
      interviewLocation: "",
      slots: [],
    });
    setShowNewSlotForm(false);
    setErrors({});
    setShowButton(true);
  };

  const handleCancel = () => {
    resetForm();
    close();
  };

  const handleScheduleConfirm = async () => {
    const requiredFields = ["interviewer", "interviewerEmail", "interviewType"];
    const newErrors = {};

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.replace(/([A-Z])/g, " $1").trim()} is required`;
      }
    });

    if (formData.interviewType === "Virtual" && !formData.meetLink) {
      newErrors.meetLink = "Meet link is required for virtual interviews";
    }
    if (formData.interviewType === "In-Person" && !formData.interviewLocation) {
      newErrors.interviewLocation = "Location is required for in-person interviews";
    }
    if (!formData.slots?.length) {
      setSnackbarMessage("Please add at least one interview slot.");
      setSnackbarSeverity("warning");
      setOpenSnackbar(true);
      return;
    }

    formData.slots.forEach((slot, index) => {
      if (!slot.fromDate) newErrors[`fromDate_${index}`] = "Interview Date is required";
      if (!slot.fromTime) newErrors[`fromTime_${index}`] = "Start Time is required";
      if (!slot.toTime) newErrors[`toTime_${index}`] = "End Time is required";
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setSnackbarMessage("Please correct the errors in the form.");
      setSnackbarSeverity("warning");
      setOpenSnackbar(true);
      scrollToInvalidField(jobTitleRef);
      return;
    }

    setIsLoading(true);
    try {
      if (status) {
        await handleShortListCandidateInBulk(selectedItems, selectedItemName);
      } else {
        await handleShortListCandidate();
      }
      setSnackbarMessage("Interview scheduled successfully!");
      setSnackbarSeverity("success");
      setOpenSnackbar(true);
      resetForm();
      close();
    } catch (error) {
      setSnackbarMessage(error.response?.data?.error || "Failed to schedule interview.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBookSlotClick = () => {
    setShowButton(false);
    handleAddSlot();
  };

  const handleCancelSlotForm = () => {
    setShowButton(true);
    setFormData((prev) => ({
      ...prev,
      slots: [],
      interviewer: "",
      interviewerEmail: "",
      interviewType: "",
      meetLink: "",
      interviewLocation: "",
    }));
    setShowNewSlotForm(false);
    setErrors({});
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenSnackbar(false);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1300,
          p: { xs: 2, sm: 4 },
          bgcolor: "rgba(0, 0, 0, 0.5)",
          transition: "background-color 0.3s ease-in-out",
        }}
      >
        <Card
          sx={{
            maxWidth: { xs: "95%", sm: 800 },
            width: "100%",
            borderRadius: 4,
            boxShadow: "0 12px 40px rgba(0, 0, 0, 0.2)",
            bgcolor: "background.paper",
            display: "flex",
            flexDirection: "column",
            maxHeight: { xs: "90vh", sm: "80vh" },
            "& .MuiTypography-root": { fontFamily: "Inter, sans-serif" },
            "& .MuiTextField-root": { fontFamily: "Inter, sans-serif" },
            "& .MuiButton-root": { fontFamily: "Inter, sans-serif" },
            "& .MuiInputLabel-root": { fontFamily: "Inter, sans-serif" },
            "& .MuiMenuItem-root": { fontFamily: "Inter, sans-serif" },
            animation: "fadeIn 0.4s ease-in-out",
            "@keyframes fadeIn": {
              from: { opacity: 0, transform: "scale(0.98)" },
              to: { opacity: 1, transform: "scale(1)" },
            },
          }}
        >
          <CardHeader
            title={selectedItemName.length > 1 ? "Bulk Interview Scheduler" : "Schedule Interview"}
            action={
              <IconButton
                onClick={close}
                sx={{ color: "grey.700", "&:hover": { color: "grey.900" } }}
                aria-label="CLOSE scheduler"
              >
                <CloseIcon />
              </IconButton>
            }
            sx={{
              textAlign: "center",
              bgcolor: "grey.100",
              py: 2,
              "& .MuiCardHeader-title": {
                fontWeight: 600,
                color: "text.primary",
                fontSize: { xs: "1.2rem", sm: "1.5rem" },
              },
            }}
          />
          <CardContent
            sx={{
              px: { xs: 3, sm: 4 },
              py: 3,
              maxHeight: { xs: "60vh", sm: "50vh" },
              overflowY: "auto",
              "&::-webkit-scrollbar": {
                width: "8px",
              },
              "&::-webkit-scrollbar-track": {
                background: "grey.100",
                borderRadius: "4px",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "grey.500",
                borderRadius: "4px",
                "&:hover": {
                  background: "grey.700",
                },
              },
            }}
          >
            {isLoading ? (
              <Box sx={{ my: 4 }}>
                <Shimmer />
                <Shimmer sx={{ width: "85%" }} />
                <Shimmer sx={{ width: "70%" }} />
              </Box>
            ) : (
              <>
                <Box sx={{ mb: 3 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: 600,
                      color: "text.primary",
                      fontSize: { xs: "0.9rem", sm: "1rem" },
                    }}
                  >
                    <strong>Job Profile:</strong> {Job_Title} ({Job_Code}) | <strong>Client:</strong> {company_Name}
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      mt: 1,
                      fontSize: { xs: "0.85rem", sm: "0.95rem" },
                      color: "text.secondary",
                    }}
                  >
                    <strong>Candidate Email(s):</strong> {selectedItemName.join(", ")}
                  </Typography>
                </Box>
                {showButton && (
                  <Box sx={{ mt: 2, textAlign: "center" }}>
                    <Button
                      startIcon={<AddIcon />}
                      onClick={handleBookSlotClick}
                      sx={{
                        bgcolor: "#3B82F6",
                        color: "white",
                        textTransform: "none",
                        fontSize: { xs: "0.9rem", sm: "1rem" },
                        fontWeight: 500,
                        borderRadius: 2,
                        px: 4,
                        py: 1,
                        "&:hover": { bgcolor: "#2563EB" },
                        transition: "all 0.3s ease-in-out",
                      }}
                      disabled={isLoading}
                      aria-label="Add new slot"
                    >
                      Book Slot
                    </Button>
                  </Box>
                )}
                {hasFetchedSlots && fetchedSlots.length > 0 && !showNewSlotForm ? (
                  <>
                    {fetchedSlots.map((slot) => (
                      <SlotCard key={slot.id}>
                        <CardContent sx={{ py: 2, px: 3 }}>
                          <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12}>
                              <Typography
                                variant="h6"
                                sx={{
                                  fontSize: { xs: "1rem", sm: "1.25rem" },
                                  fontWeight: 600,
                                  color: "text.primary",
                                }}
                              >
                                Interview Slot
                              </Typography>
                            </Grid>
                            <Grid item xs={6} sm={4}>
                              <Typography
                                variant="body2"
                                sx={{
                                  fontSize: { xs: "0.85rem", sm: "0.95rem" },
                                  color: "text.secondary",
                                }}
                              >
                                <strong>Date:</strong> {slot.fromDate || "Not set"}
                              </Typography>
                            </Grid>
                            <Grid item xs={6} sm={4}>
                              <Typography
                                variant="body2"
                                sx={{
                                  fontSize: { xs: "0.85rem", sm: "0.95rem" },
                                  color: "text.secondary",
                                }}
                              >
                                <strong>Time:</strong> {slot.interviewTime || "Not set"}
                              </Typography>
                            </Grid>
                            <Grid item xs={6} sm={4}>
                              <Typography
                                variant="body2"
                                sx={{
                                  fontSize: { xs: "0.85rem", sm: "0.95rem" },
                                  color: "text.secondary",
                                }}
                              >
                                <strong>Interviewer:</strong> {slot.interviewer || "Not set"}
                              </Typography>
                            </Grid>
                            <Grid item xs={6} sm={4}>
                              <Typography
                                variant="body2"
                                sx={{
                                  fontSize: { xs: "0.85rem", sm: "0.95rem" },
                                  color: "text.secondary",
                                }}
                              >
                                <strong>Email:</strong> {slot.interviewerEmail || "Not set"}
                              </Typography>
                            </Grid>
                            <Grid item xs={6} sm={4}>
                              <Typography
                                variant="body2"
                                sx={{
                                  fontSize: { xs: "0.85rem", sm: "0.95rem" },
                                  color: "text.secondary",
                                }}
                              >
                                <strong>Type:</strong> {slot.interviewType || "Not set"}
                              </Typography>
                            </Grid>
                            {slot.interviewType === "Virtual" && (
                              <Grid item xs={6} sm={4}>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontSize: { xs: "0.85rem", sm: "0.95rem" },
                                  }}
                                >
                                  <strong>Meet Link:</strong>{" "}
                                  <a
                                    href={slot.meetLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: "#3B82F6" }}
                                  >
                                    {slot.meetLink || "Not set"}
                                  </a>
                                </Typography>
                              </Grid>
                            )}
                            {slot.interviewType === "In-Person" && (
                              <Grid item xs={6} sm={4}>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontSize: { xs: "0.85rem", sm: "0.95rem" },
                                    color: "text.secondary",
                                  }}
                                >
                                  <strong>Location:</strong> {slot.interviewLocation || "Not set"}
                                </Typography>
                              </Grid>
                            )}
                          </Grid>
                        </CardContent>
                        <CardActions sx={{ justifyContent: "flex-end", p: 2 }}>
                          <Tooltip title="Delete this slot">
                            <IconButton
                              onClick={() => handleDeleteSlot(slot.id)}
                              disabled={isLoading}
                              sx={{
                                color: "error.main",
                                "&:hover": { color: "error.dark" },
                                fontSize: "1.2rem",
                              }}
                              aria-label="Delete slot"
                            >
                              <DeleteIcon fontSize="inherit" />
                            </IconButton>
                          </Tooltip>
                        </CardActions>
                      </SlotCard>
                    ))}
                  </>
                ) : (
                  hasFetchedSlots &&
                  !showNewSlotForm && (
                    <Box sx={{ textAlign: "center", my: 4 }}>
                      <Typography
                        variant="body1"
                        sx={{
                          fontSize: { xs: "0.9rem", sm: "1rem" },
                          color: "text.secondary",
                          mb: 2,
                        }}
                      >
                        No interview slots available. Add a new slot to schedule an interview.
                      </Typography>
                    </Box>
                  )
                )}

                {showNewSlotForm && (
                  <Box ref={jobTitleRef} sx={{ mt: 3, p: 2, bgcolor: "grey.50", borderRadius: 2 }}>
                    <Typography
                      variant="h6"
                      sx={{
                        fontSize: { xs: "1rem", sm: "1.25rem" },
                        fontWeight: 600,
                        mb: 3,
                        color: "text.primary",
                      }}
                    >
                      Add New Interview Slot
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Interviewer Name"
                          id="interviewer"
                          value={formData.interviewer}
                          onChange={handleInputChange}
                          error={!!errors.interviewer}
                          helperText={errors.interviewer}
                          required
                          disabled={isLoading}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: 2,
                              "& fieldset": { borderColor: "grey.300" },
                              "&:hover fieldset": { borderColor: "#3B82F6" },
                              "&.Mui-focused fieldset": { borderColor: "#3B82F6" },
                              transition: "all 0.3s ease-in-out",
                            },
                            "& .MuiInputLabel-root": {
                              color: "text.secondary",
                              "&.Mui-focused": { color: "#3B82F6" },
                              fontSize: { xs: "0.9rem", sm: "1rem" },
                            },
                            "& .MuiInputBase-input": { fontSize: { xs: "0.9rem", sm: "1rem" } },
                            "& .MuiFormHelperText-root": { fontSize: "0.8rem" },
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Interviewer Email"
                          id="interviewerEmail"
                          value={formData.interviewerEmail}
                          onChange={handleInputChange}
                          error={!!errors.interviewerEmail}
                          helperText={errors.interviewerEmail}
                          required
                          disabled={isLoading}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: 2,
                              "& fieldset": { borderColor: "grey.300" },
                              "&:hover fieldset": { borderColor: "#3B82F6" },
                              "&.Mui-focused fieldset": { borderColor: "#3B82F6" },
                              transition: "all 0.3s ease-in-out",
                            },
                            "& .MuiInputLabel-root": {
                              color: "text.secondary",
                              "&.Mui-focused": { color: "#3B82F6" },
                              fontSize: { xs: "0.9rem", sm: "1rem" },
                            },
                            "& .MuiInputBase-input": { fontSize: { xs: "0.9rem", sm: "1rem" } },
                            "& .MuiFormHelperText-root": { fontSize: "0.8rem" },
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <FormControl fullWidth required error={!!errors.interviewType}>
                          <InputLabel
                            sx={{
                              color: "text.secondary",
                              "&.Mui-focused": { color: "#3B82F6" },
                              fontSize: { xs: "0.9rem", sm: "1rem" },
                            }}
                          >
                            Interview Type
                          </InputLabel>
                          <Select
                            name="interviewType"
                            id="interviewType"
                            value={formData.interviewType}
                            onChange={handleInputChange}
                            disabled={isLoading}
                            sx={{
                              borderRadius: 2,
                              "& .MuiOutlinedInput-notchedOutline": { borderColor: "grey.300" },
                              "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#3B82F6" },
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#3B82F6" },
                              fontSize: { xs: "0.9rem", sm: "1rem" },
                              transition: "all 0.3s ease-in-out",
                            }}
                          >
                            <MenuItem value="" sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}>
                              Select Interview Type
                            </MenuItem>
                            <MenuItem value="In-Person" sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}>
                              In-Person
                            </MenuItem>
                            <MenuItem value="Virtual" sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}>
                              Virtual
                            </MenuItem>
                          </Select>
                          {errors.interviewType && (
                            <Typography
                              variant="caption"
                              color="error"
                              sx={{ fontSize: "0.8rem", mt: 0.5 }}
                            >
                              {errors.interviewType}
                            </Typography>
                          )}
                        </FormControl>
                      </Grid>
                      {formData.interviewType && (
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            label={formData.interviewType === "Virtual" ? "Platform/Meet Link" : "Interview Location"}
                            id={formData.interviewType === "Virtual" ? "meetLink" : "interviewLocation"}
                            value={formData.interviewType === "Virtual" ? formData.meetLink : formData.interviewLocation}
                            onChange={handleInputChange}
                            error={!!errors[formData.interviewType === "Virtual" ? "meetLink" : "interviewLocation"]}
                            helperText={errors[formData.interviewType === "Virtual" ? "meetLink" : "interviewLocation"]}
                            required={formData.interviewType === "Virtual" || formData.interviewType === "In-Person"}
                            disabled={isLoading}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                borderRadius: 2,
                                "& fieldset": { borderColor: "grey.300" },
                                "&:hover fieldset": { borderColor: "#3B82F6" },
                                "&.Mui-focused fieldset": { borderColor: "#3B82F6" },
                                transition: "all 0.3s ease-in-out",
                              },
                              "& .MuiInputLabel-root": {
                                color: "text.secondary",
                                "&.Mui-focused": { color: "#3B82F6" },
                                fontSize: { xs: "0.9rem", sm: "1rem" },
                              },
                              "& .MuiInputBase-input": { fontSize: { xs: "0.9rem", sm: "1rem" } },
                              "& .MuiFormHelperText-root": { fontSize: "0.8rem" },
                            }}
                          />
                        </Grid>
                      )}
                      {formData.slots.map((slot, index) => (
                        <SlotCard key={slot.id} sx={{ mt: 2 }}>
                          <CardContent sx={{ py: 2, px: 3 }}>
                            <Grid container spacing={2} alignItems="center">
                              <Grid item xs={12} sm={4}>
                                <TextField
                                  fullWidth
                                  type="date"
                                  label="Interview Date"
                                  id="fromDate"
                                  value={slot.fromDate}
                                  onChange={(e) => handleInputChange(e, slot.id)}
                                  InputLabelProps={{ shrink: true }}
                                  required
                                  disabled={isLoading}
                                  error={!!errors[`fromDate_${index}`]}
                                  helperText={errors[`fromDate_${index}`]}
                                  sx={{
                                    "& .MuiOutlinedInput-root": {
                                      borderRadius: 2,
                                      "& fieldset": { borderColor: "grey.300" },
                                      "&:hover fieldset": { borderColor: "#3B82F6" },
                                      "&.Mui-focused fieldset": { borderColor: "#3B82F6" },
                                      transition: "all 0.3s ease-in-out",
                                    },
                                    "& .MuiInputLabel-root": {
                                      color: "text.secondary",
                                      "&.Mui-focused": { color: "#3B82F6" },
                                      fontSize: { xs: "0.9rem", sm: "1rem" },
                                    },
                                    "& .MuiInputBase-input": { fontSize: { xs: "0.9rem", sm: "1rem" } },
                                    "& .MuiFormHelperText-root": { fontSize: "0.8rem" },
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} sm={4}>
                                <TextField
                                  fullWidth
                                  type="time"
                                  label="Start Time"
                                  id="fromTime"
                                  value={slot.fromTime}
                                  onChange={(e) => handleInputChange(e, slot.id)}
                                  InputLabelProps={{ shrink: true }}
                                  required
                                  disabled={isLoading}
                                  error={!!errors[`fromTime_${index}`]}
                                  helperText={errors[`fromTime_${index}`]}
                                  sx={{
                                    "& .MuiOutlinedInput-root": {
                                      borderRadius: 2,
                                      "& fieldset": { borderColor: "grey.300" },
                                      "&:hover fieldset": { borderColor: "#3B82F6" },
                                      "&.Mui-focused fieldset": { borderColor: "#3B82F6" },
                                      transition: "all 0.3s ease-in-out",
                                    },
                                    "& .MuiInputLabel-root": {
                                      color: "text.secondary",
                                      "&.Mui-focused": { color: "#3B82F6" },
                                      fontSize: { xs: "0.9rem", sm: "1rem" },
                                    },
                                    "& .MuiInputBase-input": { fontSize: { xs: "0.9rem", sm: "1rem" } },
                                    "& .MuiFormHelperText-root": { fontSize: "0.8rem" },
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} sm={3}>
                                <TextField
                                  fullWidth
                                  type="time"
                                  label="End Time"
                                  id="toTime"
                                  value={slot.toTime}
                                  onChange={(e) => handleInputChange(e, slot.id)}
                                  InputLabelProps={{ shrink: true }}
                                  required
                                  disabled={isLoading}
                                  error={!!errors[`toTime_${index}`]}
                                  helperText={errors[`toTime_${index}`]}
                                  sx={{
                                    "& .MuiOutlinedInput-root": {
                                      borderRadius: 2,
                                      "& fieldset": { borderColor: "grey.300" },
                                      "&:hover fieldset": { borderColor: "#3B82F6" },
                                      "&.Mui-focused fieldset": { borderColor: "#3B82F6" },
                                      transition: "all 0.3s ease-in-out",
                                    },
                                    "& .MuiInputLabel-root": {
                                      color: "text.secondary",
                                      "&.Mui-focused": { color: "#3B82F6" },
                                      fontSize: { xs: "0.9rem", sm: "1rem" },
                                    },
                                    "& .MuiInputBase-input": { fontSize: { xs: "0.9rem", sm: "1rem" } },
                                    "& .MuiFormHelperText-root": { fontSize: "0.8rem" },
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} sm={1}>
                                <Tooltip title="Delete this slot">
                                  <IconButton
                                    onClick={() => handleDeleteSlot(slot.id)}
                                    disabled={isLoading}
                                    sx={{
                                      color: "error.main",
                                      "&:hover": { color: "error.dark" },
                                      fontSize: "1.2rem",
                                    }}
                                    aria-label="Delete slot"
                                  >
                                    <DeleteIcon fontSize="inherit" />
                                  </IconButton>
                                </Tooltip>
                              </Grid>
                              {slot.interviewTime && (
                                <Grid item xs={12}>
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      color: "#3B82F6",
                                      fontSize: { xs: "0.9rem", sm: "1rem" },
                                      fontWeight: 500,
                                    }}
                                  >
                                    Scheduled: {slot.interviewTime}
                                  </Typography>
                                </Grid>
                              )}
                            </Grid>
                          </CardContent>
                        </SlotCard>
                      ))}
                      <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
                        <Button
                          startIcon={<AddIcon />}
                          onClick={handleAddAnotherSlot}
                          sx={{
                            bgcolor: "#10B981",
                            color: "white",
                            textTransform: "none",
                            fontSize: { xs: "0.9rem", sm: "1rem" },
                            fontWeight: 500,
                            borderRadius: 2,
                            px: 4,
                            py: 1,
                            "&:hover": { bgcolor: "#059669" },
                            transition: "all 0.3s ease-in-out",
                          }}
                          disabled={isLoading}
                          aria-label="Add another slot"
                        >
                          Add Another Slot
                        </Button>
                        <Button
                          startIcon={<CancelIcon />}
                          variant="outlined"
                          onClick={handleCancelSlotForm}
                          disabled={isLoading}
                          sx={{
                            borderColor: "error.main",
                            color: "error.main",
                            textTransform: "none",
                            fontWeight: 500,
                            fontSize: { xs: "0.9rem", sm: "1rem" },
                            borderRadius: 2,
                            px: 4,
                            py: 1,
                            "&:hover": { borderColor: "error.dark", bgcolor: "error.light" },
                            transition: "all 0.3s ease-in-out",
                          }}
                          aria-label="Cancel slot form"
                        >
                          Cancel
                        </Button>
                      </Box>
                    </Grid>
                  </Box>
                )}
              </>
            )}
          </CardContent>
          <CardActions sx={{ justifyContent: "space-between", px: { xs: 3, sm: 4 }, py: 2, bgcolor: "grey.100" }}>
            <Button
              variant="outlined"
              onClick={handleCancel}
              disabled={isLoading}
              sx={{
                borderRadius: 2,
                borderColor: "grey.500",
                color: "text.primary",
                textTransform: "none",
                fontWeight: 500,
                fontSize: { xs: "0.9rem", sm: "1rem" },
                px: 4,
                py: 1,
                "&:hover": { borderColor: "grey.700", bgcolor: "grey.200" },
                transition: "all 0.3s ease-in-out",
              }}
              aria-label="Cancel scheduler"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleScheduleConfirm}
              disabled={
                isLoading ||
                selectedItemName.length === 0 ||
                !formData.interviewer ||
                !formData.slots?.length ||
                Object.keys(errors).length > 0
              }
              sx={{
                borderRadius: 2,
                bgcolor: "#3B82F6",
                color: "#FFFFFF",
                textTransform: "none",
                fontWeight: 500,
                fontSize: { xs: "0.9rem", sm: "1rem" },
                px: 4,
                py: 1,
                "&:hover": { bgcolor: "#2563EB" },
                "&.Mui-disabled": { bgcolor: "grey.400", color: "grey.50" },
                transition: "all 0.3s ease-in-out",
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
              aria-label={selectedItemName.length > 1 ? "Schedule now" : "Save"}
            >
              {isLoading ? <CircularProgress size={20} color="inherit" /> : null}
              {isLoading ? "Scheduling..." : selectedItemName.length > 1 ? "Schedule Now" : "Save"}
            </Button>
          </CardActions>
        </Card>
      </Box>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        sx={{
          maxWidth: { xs: "90%", sm: "400px" },
          mx: "auto",
          animation: "slideIn 0.3s ease-in-out",
          "@keyframes slideIn": {
            from: { opacity: 0, transform: "translateY(20px)" },
            to: { opacity: 1, transform: "translateY(0)" },
          },
        }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{
            fontSize: { xs: "0.9rem", sm: "1rem" },
            borderRadius: 2,
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          }}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
};

export default InterviewSchedulerPage;